export class DataCatalogMaskTransform {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "kind",
            "baseName": "kind",
            "type": "DataCatalogMaskTransformKind",
            "format": ""
        },
        {
            "name": "defaultValue",
            "baseName": "defaultValue",
            "type": "DataCatalogRowLiteral",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return DataCatalogMaskTransform.attributeTypeMap;
    }
    constructor() {
    }
}
